export default "__VITE_ASSET__CONJXtyS__"